import styled from "styled-components";
import { Button as AntButton } from "antd";

export const RootContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	gap: 16px;
	padding: 0 0 20px 0;
  position: relative;
`;

export const SkipButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  position: absolute;
  top: 16px;
  right: 16px;
`;

export const SkipButton = styled.div`
  cursor: pointer;
  border-radius: 16px;
  background: rgba(0, 0, 0, 0.50);
  backdrop-filter: blur(25px);
  padding: 4px 10px;

  color: #FFF;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 1.5;
  text-transform: uppercase;
`;

export const Title = styled.div`
	color: #006400;
	text-align: center;
	font-size: 18px;
	font-style: normal;
	font-weight: 700;
	line-height: 34px; /* 141.667% */

	@media screen and (max-width: 425px) {
		font-size: 17px;
	}

	@media screen and (max-width: 375px) {
		font-size: 15px;
	}
`;

export const Description = styled.div`
  color: #4F4F4F;
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; /* 155.556% */

  span {
    font-weight: bold;
  }

  width: 80%;
`;

export const RuleWrapper = styled.div`
	padding: 16px;
	border-radius: 20px;
border: 1px solid var(--STROKE-GRAY, #999);
background: #E6FCE6;
backdrop-filter: blur(25px);
	width: calc(100% - 32px);
	box-sizing: border-box;
`;

export const RuleTitle = styled.div`
	text-align: center;
	margin: 0 auto;
	margin-bottom: 16px;

	color: #006400;
	text-align: center;
	font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: 26px; /* 162.5% */
`;

export const Rule = styled.div`
	margin: 0px;
	color: #4F4F4F;
	text-align: left;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 1.5;

	ul {
		padding-inline-start: 16px !important;
	}
`;

export const ButtonWrapper = styled.div`
  width: calc(100% - 32px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

`;

export const Button = styled(AntButton)`
  width: 100% !important;
  height: 56px !important;
`;

export const TopImage = styled.img.attrs(props => ({
	alt: 'img',
	src: props.src
}))`
	/* background-image: ${props  => `url(${props.src})`} ;
	background-size: cover;
	background-repeat: no-repeat;
	background-position: bottom; */

	width: 100%;
	height: auto;
`